// Per-session persistence for the pending send-queue (B10 — ported from gwd).
//
// The kit's send-queue (messages typed while a turn is streaming) is in-memory
// React state, so a reload/restart mid-turn loses it. We persist it to
// localStorage keyed by the Link session id and restore it via agent.seedQueue on
// resume — the browser analog of gwd's per-chat file sidecar. Restore is ordered
// against the turn state by useLinkAgentSession so a restored queue never
// dispatches into a still-running turn.
import type { QueuedMessage } from 'jasit-agent-kit/react';

const key = (sessionId: string) => `linkAgentQueue:${sessionId}`;

export const linkQueueStore = {
    /** The stored pending queue for a session (empty when none / unavailable). */
    get(sessionId: string | null): QueuedMessage[] {
        if (!sessionId) return [];
        try {
            const raw = localStorage.getItem(key(sessionId));
            return raw ? (JSON.parse(raw) as QueuedMessage[]) : [];
        } catch {
            return [];
        }
    },
    /** Persist the pending queue (removes the key when empty). */
    save(sessionId: string | null, items: QueuedMessage[]): void {
        if (!sessionId) return;
        try {
            if (items.length) localStorage.setItem(key(sessionId), JSON.stringify(items));
            else localStorage.removeItem(key(sessionId));
        } catch {
            /* quota exceeded / storage disabled — the queue just won't survive a reload */
        }
    },
};
